import { Form, Row, Col, Button } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import { isValidPhone } from '../../../common/validators';

function ContactInfoForm({ form, setForm, stepSubmitted }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleOwnerChange = (name, value) => {
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleContactPersonChange = (index, field, value) => {
        const updatedContacts = [...form.contact_persons];
        updatedContacts[index][field] = value;
        setForm(prev => ({ ...prev, contact_persons: updatedContacts }));
    };

    const addContactPerson = () => {
        setForm(prev => ({
            ...prev,
            contact_persons: [...prev.contact_persons, { name: '', number: '' }]
        }));
    };

    const removeContactPerson = (index) => {
        const updatedContacts = form.contact_persons.filter((_, i) => i !== index);
        setForm(prev => ({ ...prev, contact_persons: updatedContacts }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Owner Name <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            name="owner_name"
                            value={form.owner_name}
                            onChange={(e) => handleOwnerChange('owner_name', e.target.value)}
                            isInvalid={stepSubmitted && !form.owner_name}
                        />
                        <Form.Control.Feedback type="invalid">
                            Owner Name is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Owner Contact Number <span className="text-danger">*</span></Form.Label>
                        <PhoneInput
                            country="in"
                            value={form.owner_contact_no}
                            onChange={(value) =>
                                handleOwnerChange('owner_contact_no', `+${value}`)
                            }
                            inputProps={{ name: 'owner_contact_no', required: false }}
                            inputClass={
                                stepSubmitted && (!form.owner_contact_no || !isValidPhone(form.owner_contact_no))
                                    ? 'is-invalid'
                                    : ''
                            }
                        />
                        {stepSubmitted && !form.owner_contact_no && (
  <div className="invalid-feedback d-block">
    Owner Contact Number is required.
  </div>
)}
                        {form.owner_contact_no && !isValidPhone(form.owner_contact_no) && (
                            <div className="invalid-feedback d-block">
                                Enter a valid phone number with country code
                            </div>
                        )}
                    </Form.Group>
                </Col>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Business Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="business_email"
                            value={form.business_email}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <hr />
            <h6 className="mb-2">Key Contact Persons</h6>
            {form.contact_persons.map((person, index) => (
                <Row key={index} className="align-items-end mb-2">
                    <Col md={5} xl={4}>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                value={person.name}
                                onChange={(e) =>
                                    handleContactPersonChange(index, 'name', e.target.value)
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={10} md={6} xl={4}>
                        <Form.Group>
                            <Form.Label>Number</Form.Label>
                            <PhoneInput
                                country="in"
                                value={person.number}
                                onChange={(val) =>
                                    handleContactPersonChange(index, 'number', `+${val}`)
                                }
                                inputClass={
                                    person.number && !isValidPhone(person.number)
                                        ? 'is-invalid'
                                        : ''
                                }
                            />
                            {person.number && !isValidPhone(person.number) && (
                                <div className="invalid-feedback d-block">
                                    Invalid phone number
                                </div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col xs={2} md={1} className="ps-md-0">
                        {form.contact_persons.length > 1 && index > 0 && (
                            <Button
                                variant="danger"
                                size="sm"
                                onClick={() => removeContactPerson(index)}
                            >
                                x
                            </Button>
                        )}
                    </Col>
                    <hr className="mt-3 mb-0" />
                </Row>
            ))}

            <Button variant="secondary" size="sm" onClick={addContactPerson}>
                + Add Contact Person
            </Button>
        </div>
    );
}

ContactInfoForm.validate = function (form) {
    return (
        !!form.owner_name &&
        !!form.owner_contact_no &&
    isValidPhone(form.owner_contact_no)
    );
};

export default ContactInfoForm;
